export function createCustomerProfileClient(transport) {
    return {
        /**
         * List this tenant's customers, newest first
         *
         * Requires scope: customer-profile:read, customer-profile:roster
         */
        listCustomerProfiles(status, identitySubjectId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/customer-profiles",
                query: { status: status, identitySubjectId: identitySubjectId, limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /v1/customer-profiles
         *
         * Requires scope: customer-profile:create
         */
        createCustomerProfile(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/customer-profiles",
                body,
                options,
            });
        },
        /**
         * GET /v1/customer-profiles/{profileId}
         *
         * Requires scope: customer-profile:read
         */
        getCustomerProfile(profileId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/customer-profiles/${encodeURIComponent(profileId)}`,
                options,
            });
        },
        /**
         * PATCH /v1/customer-profiles/{profileId}
         *
         * Requires scope: customer-profile:lifecycle:write, customer-profile:update
         */
        updateCustomerProfile(profileId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/customer-profiles/${encodeURIComponent(profileId)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=customer-profile.js.map